import React from 'react';
import Carrasco from './../img/Sucursales/carrasco.jpg';
import MapContainer from '../components/MapContainer';
import PuntaCarretas from'./../img/Sucursales/puntaCarretas.jpg'
import Italia from './../img/Sucursales/italia.jpg'
import Geant from './../img/Sucursales/geant.jpg'
import Tahona from './../img/Sucursales/tahona.jpg'

/*
-las delicias plaza italia
-/parque miramar
-/geant
-/carrasco
-/pocitos
-/solanas
//la tahona
*/

const locations = [
  {
    "id": 1,
    "name": "Carrasco",
    "address": "Dr. Alejandro Schroeder 6454, 11500 Montevideo, Uruguay",
    "phone": "2 600 24 77",
    "img": Carrasco
  },
  {
    "id": 2,
    "name": "Pocitos",
    "address": "Ellauri 350, 11300 Montevideo, Uruguay",
    "phone": "2 710 98 57",
    "img": PuntaCarretas
  },
  {
    "id": 3,
    "name": "Parque Miramar",
    "address": "Gabriela Mistral 2127, 15000 Canelones, Uruguay",
    "phone": "2 605 77 20",
    "img": Carrasco
  },
  {
    "id": 4,
    "name": "Géant",
    "address": "Av. a la Playa 15000",
    "phone": "2 600 48 81",
    "img": Geant
  },
  {
    "id": 5,
    "name": "Solanas - Punta del Este",
    "address": "Juan Díaz de Solís 120, 20000 Maldonado, Uruguay",
    "phone": "2 600 24 77",
    "img": Carrasco
  },
  {
    "id": 6,
    "name": "Plaza Italia",
    "address": "Avenida Italia 4250, 11400 Montevideo, Uruguay",
    "phone": "2 600 24 77",
    "img": Italia
  },
  {
    "id": 7,
    "name": "La Tahona",
    "address": "Camino de Los Horneros km 3, 15800 Canelones, Uruguay",
    "phone": "2 600 24 77",
    "img": Tahona
  }
];

// Función para manejar el desplazamiento a la sección con el ID especificado
const handleScrollTo = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

function Sucursales() {
  return (
    <div>
      <h1>Nuestras Sucursales</h1>
      <MapContainer addresses={locations} handleScrollTo={handleScrollTo} />
    </div>
  );
}

export default Sucursales;
